<template>
    <footer class="mt-auto pb-2 pt-8">
        <div class="container mx-auto px-4">
            <div class="flex flex-col items-center justify-between xl:flex-row text-sm">
                <nav class="flex flex-col xl:block text-center">
                    <a class="hover:underline mb-4 xl:mb-0 xl:mr-4 xl:w-1/5 text-slate-800" href="/privacy-policy" target="_blank">
                        {{ __('Adatkezelési tájékoztató') }}
                    </a>
                    <a class="hover:underline mb-4 xl:mb-0 xl:mr-4 xl:w-1/5 text-slate-800" href="/terms" target="_blank">
                        {{ __('ÁSZF') }}
                    </a>
                    <a class="hover:underline mb-4 xl:mb-0 xl:mr-4 xl:w-1/5 text-slate-800" href="/cookies" target="_blank">
                        {{ __('Süti tájékoztató') }}
                    </a>
                    <a class="hover:underline mb-4 xl:mb-0 xl:mr-4 xl:w-1/5 text-slate-800" href="/impressum" target="_blank">
                        {{ __('Impresszum') }}
                    </a>
                    <a class="hover:underline mb-4 xl:mb-0 xl:mr-4 xl:w-1/5 text-slate-800" href="tel:+36704298964">
                        +36 70 429 8964
                    </a>
                    <a class="hover:underline mb-4 xl:mb-0 xl:w-1/5 text-slate-800" href="mailto:rendeles@pipacspekseg.hu">
                        rendeles@pipacspekseg.hu
                    </a>
                </nav>
                <nav class="flex flex-col items-center mb-4 xl:flex-row xl:mb-0 xl:order-none xl:w-1/3 order-first">
                    <span class="mb-4 xl:mb-0 ml-auto mr-4">Copyright &copy; {{ new Date().getFullYear() }} Pipacs Pékség</span>
                    <div class="flex">
                        <a class="mr-4" href="https://www.facebook.com/pipacspekseg">
                            <img class="h-6" src="/img/icon-facebook.png" alt="Facebook" />
                        </a>
                        <a href="https://www.instagram.com/pipacspekseg">
                            <img class="h-6" src="/img/icon-instagram.png" alt="Instagram" />
                        </a>
                    </div>
                </nav>
            </div>
        </div>
    </footer>
</template>
<script setup lang="ts">
</script>